export default __webpack_public_path__ + "b8bd2d85073d53a3d5d96491cf9b80c3.svg";